import React, { Component } from 'react';
import { connect } from 'react-redux';
import {fundActions} from '../../../../actions/trading/fund.actions'
import '@/assets/styles/components/fund-management/exchange-instruction-mobile.scss';
import Dropdown from '@/components/Dropdown/Dropdown';
import fundtransfer_icon from '@/assets/images/icons/icon_fundtransfer.png';
import fundtransfer_icon_light from '@/assets/images/icons/icon_fundtransfer_light.png';
import { PARAMS } from '../../../../constants/params';
import { formatFunctions, Validators, utilsFunction} from '../../../../helpers/functions';
import { dataType } from '@/constants/data-type';
import { SERVICES_RESP as servicesResp , Icons} from '../../../../configurations';
import { settingConfigs } from '../../../../configurations';
import {openTranSferResultDialog} from '../../../../actions/app';
import Tips from '../../../../components/Tips/Tips';
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '../../../../components/Spinner/LoadingLayer';

class ExchangeInstructionMobile extends React.Component {
    constructor(props) {
        super(props);
        props.innerRef(this);
        this.state = {
            fromCurrencyOption: this.props.ccy,
            selectFromCurrency: this.props.ccy[0].value,
            toCurrencyOption: [],
            selectToCurrency: [],
            fromAmount: '',
            toAmount:'',
            balance: '-',
            conversionRate: '',
            buyingExchangeRate: '',
            sellingExchangeRate: '',
            errorMessage: '',
            isLoading: false
        }
    }

    selectCurrency = (val,param = 'from') => {
        const {fromCurrencyOption} = this.state;
        if(param === 'from'){
            const selectFromCurrency = val[0].value;
            let toCurrencyOption = [];
            fromCurrencyOption.map(item => {
                if(item.value != selectFromCurrency){
                    toCurrencyOption.push(item);
                }
            })
            this.setState({
                selectFromCurrency: selectFromCurrency,
                toCurrencyOption: toCurrencyOption,
                selectToCurrency: toCurrencyOption[0].value,
            },() => {
                this.setWithdrawableBalance();
                this.queryCurrencyConversion();
            })
        } else {
            const selectToCurrency = val[0].value;
            this.setState({
                selectToCurrency: selectToCurrency,
            },() => {
                this.queryCurrencyConversion();
            })
        }
    }

    inputAmount = (e) => {
        const {conversionRate} = this.state;
        let value = e.target.value;
        value = value.replaceAll(settingConfigs.CASH.thousandSeparator, '');
        let isValid = false;
        if (value) {
            if(value.length < 16){
                if (Validators.currency(value, settingConfigs.CASH.decimalSeparator, settingConfigs.CASH.decimal)) {
                    isValid = true
                }
            }
        } else {
            isValid = true;
        }
        if(isValid){
            if(value[value.length] !== '.'){
                const toAmount = utilsFunction.formatNumber(Number(value) * Number(conversionRate), 2);
                this.setState({
                    fromAmount:value,
                    toAmount:toAmount
                })
            }
        }
    }

    setWithdrawableBalance = () =>{
        const { selectFromCurrency } = this.state;
        let params = {
            [PARAMS.CURRENCY_ID]:selectFromCurrency
        }
        this.props.withdrawableBalanceEnquiry(params, res=>{
            if(res.result.drawableBalance && res.result.drawableBalance !== ''){
                this.setState({
                    balance:res.result.drawableBalance
                })
            }else{
                this.setState({
                    balance:'-'
                })
            }
        })
    }

    resetOption = () =>{
        const{ccy} = this.props;
        this.setState({
            selectFromCurrency:this.props.ccy[0].value,
            selectToCurrency:'',
            toCurrencyOption:[],
            fromAmount: '',
            toAmount: '',
            balance: '-',
            errorMessage: ''
        },() => {
            this.selectCurrency([ccy[0]]);
        })
        this.formCurrencyOptionRef.setValue([ccy[0]]);
        this.toCurrencyOptionRef.setValue(this.state.toCurrencyOption[0]);
    }

    queryCurrencyConversion = () => {
        const {language,currentTradingAccount,user} = this.props;
        const { clientID, tradingAccSeq } = currentTradingAccount;
        const {selectFromCurrency, selectToCurrency, fromAmount} = this.state;
        const params = {
            [PARAMS.CLIENT_ID]: clientID,
            [PARAMS.TRADING_ACCOUNT_ID]: clientID,
            [PARAMS.TRADING_ACC_SEQ]:String(tradingAccSeq),
            [PARAMS.LANGUAGE]: language.lang,
            [PARAMS.FROM_CURRENCY]:selectFromCurrency,
            [PARAMS.TO_CURRENCY]:selectToCurrency
        }
        // this.setState({
        //     isLoading:true
        // })
        this.props.queryCurrencyConversionAction(params,res => {
            if(res.result.errorCode === servicesResp.SUCCESS_CODE){
                // const conversionRate = res.result.exchangeRateWeb;
                const conversionRate = res.result.exchangeRateWeb;
                this.setState({
                    conversionRate:conversionRate,
                    // buyingExchangeRate:res.result.exchangeRateWeBuy,
                    // sellingExchangeRate:res.result.exchangeRateWeSell,
                    // isLoading:false
                },() => {
                    if(fromAmount){
                        const {fromAmount, conversionRate} = this.state;
                        this.setState({
                            toAmount:utilsFunction.formatNumber(Number(fromAmount) * Number(conversionRate), 2)
                        })
                    }
                })
            }
        })
    }

    transferSubmit = () =>{
        const {language,currentTradingAccount,user} = this.props;
        const {selectFromCurrency,selectToCurrency,fromAmount,toAmount,conversionRate} = this.state;
        const { clientID, tradingAccSeq } = currentTradingAccount;
        let isValid = false;
        this.setState({
            errorMessage:''
        })
        if(fromAmount && toAmount){
            isValid = true
        }else{
            this.setState({
                errorMessage: language.fund_management_enter_amount
            })
        }
        if(isValid){
            this.setState({isLoading : true})
            let params = {
                [PARAMS.CLIENT_ID]: clientID,
                [PARAMS.TRADING_ACCOUNT_ID]: clientID,
                [PARAMS.TRADING_ACC_SEQ]:String(tradingAccSeq),
                [PARAMS.LANGUAGE]: language.lang,
                [PARAMS.FROM_CURRENCY]:selectFromCurrency,
                [PARAMS.TO_CURRENCY]:selectToCurrency,
                [PARAMS.FROM_AMOUNT]:fromAmount.replaceAll(',',''),
                [PARAMS.TO_AMOUNT]:toAmount.replaceAll(',',''),
                [PARAMS.EXCHANGE_RATE]: String(conversionRate),
                [PARAMS.FROM_BANKID]: 'N/A',
                [PARAMS.TO_BANKID]: 'N/A',
                [PARAMS.FROM_BANKACCTID]: 'N/A',
                [PARAMS.TO_BANKACCTID]: 'N/A',
            }
            this.props.foreignExchangeAction(params,res => {
                if(res.result.errorCode === servicesResp.SUCCESS_CODE){
                    if(res.result.tranID){
                        const {pageID} = this.props;
                        const transactionID = res.result.tranID;
                        this.resetOption();
                        // this.setWithdrawableBalance()
                        // this.props.handleSearchData();
                        openTranSferResultDialog(transactionID,pageID);
                    }
                }else{
                    this.setState({
                        errorMessage:res.result.errorMessage
                    })
                }
                this.setState({isLoading : false})
            })
        }
    }

    componentDidMount(){
        const {ccy} = this.props;
        this.selectCurrency([ccy[0]]);
    }

    render() { 
        const {language, theme} = this.props;
        const {fromCurrencyOption, selectFromCurrency, toCurrencyOption, selectToCurrency, fromAmount, toAmount, balance, conversionRate, buyingExchangeRate, sellingExchangeRate, errorMessage, isLoading} = this.state;
        return (
            <div className='exchange-instruction'>
                <LoadingLayer load={isLoading} type={LOADING_TYPE.BIG_IMG} />
                <div className='exchange-instruction-container'>
                    {errorMessage &&
                        <div>
                            <Tips isSuccess={false} isNoBgColor={true} >{errorMessage}</Tips>
                        </div>
                    }
                    <div className='container-currency'>
                        <div className='container-currency-title'>
                            {language.fund_currency}
                        </div>
                        <div className='container-currency-options'>
                            <div className='options-from'>
                                <Dropdown
                                    style={{ height: '30px', backgroundColor: '#1B2129' }}
                                    selectedOptions={[fromCurrencyOption[0]]}
                                    options={fromCurrencyOption}
                                    onChange={(val) => this.selectCurrency(val,'from')}
                                    innerRef={e =>this.formCurrencyOptionRef = e}/>
                            </div>
                            <div className='options-icon'>
                                <img src={theme === 'light' ? fundtransfer_icon_light : fundtransfer_icon} alt="" />
                            </div>
                            <div className='options-to'>
                                <Dropdown
                                    style={{ height: '30px', backgroundColor: '#1B2129' }}
                                    selectedOptions={[toCurrencyOption[0]]}
                                    options={toCurrencyOption}
                                    onChange={(val) => this.selectCurrency(val,'to')}
                                    innerRef={e =>this.toCurrencyOptionRef = e}/>
                            </div>
                        </div>
                    </div>
                    <div className='container-from-amount'>
                        <div className='container-from-amount-title'>
                            {language.fund_from_amount}
                        </div>
                        <div className='container-from-amount-input'>
                            <label>{selectFromCurrency}</label>
                            <input
                               type="text" 
                               value={fromAmount}
                               placeholder={language.fund_management_enter_amount}
                               onChange={(e) => this.inputAmount(e)}
                               />
                        </div>
                        <div className='container-from-amount-balance'>
                            {language.fund_management_transfer_balance}&nbsp;
                            {`${selectFromCurrency} ${formatFunctions.dataFormat(balance,dataType.CASH)}`}
                        </div>
                        <div className='container-from-amount-buying'>
                            {language.fund_management_exchange_rate} &nbsp;
                            {conversionRate}
                        </div>
                        {/* <div className='container-from-amount-buying'>
                            {language.fund_management_exchange_rate_buy}&nbsp;
                            {buyingExchangeRate}
                        </div> */}
                        {/* <div className='container-from-amount-selling'>
                            {language.fund_management_exchange_rate_sell}&nbsp;
                            {sellingExchangeRate}
                        </div> */}
                    </div>
                    <div className='container-to-amount'>
                        <div className='container-to-amount-title'>
                            {language.fund_to_amount}
                        </div>
                        <div className='container-to-amount-value'>
                            {`${selectToCurrency} ${toAmount ? toAmount : '-'}`}
                            <div className='container-to-amount-text'>{language.fund_management_for_reference_only}</div>
                        </div>
                    </div>
                </div>
                <div className='exchange-instruction-button'>
                    <button className='button-clear' onClick={() => this.resetOption()}>
                        {language.common_clear}
                    </button>
                    <button className='button-submit' onClick={() => this.transferSubmit()} disabled={isLoading}>
                        {isLoading? <Icons.Loading/> : language.common_submit}
                    </button>
                </div>
            </div>
        );
    }
}
 
export default connect(
    state => ({
        language: state.app.language,
        currentTradingAccount: state.trade.currentTradingAccount,
        user: state.auth.user,
        theme: state.app.theme
    }),
    dispatch => ({
        // cashDWAction:(p,res) => dispatch(fundActions.cashDWAction(p,res)),
        withdrawableBalanceEnquiry:(p,res) => dispatch(fundActions.withdrawableBalanceEnquiryAction(p,res)),
        queryCurrencyConversionAction:(p,res) => dispatch(fundActions.queryCurrencyConversionAction(p,res)),
        foreignExchangeAction:(p,res) => dispatch(fundActions.foreignExchangeAction(p,res)),
    })
)(ExchangeInstructionMobile)